export default {
      id: "shipment__group-usage",
      viewBox: "0 0 50 34",
      url: __webpack_public_path__ + "img/icons.svg#shipment__group",
      toString: function () {
        return this.url;
      }
    }